// src/providers/logger.tsx
import {
  datadogLogs
} from "@datadog/browser-logs";
import React from "react";
import { jsx } from "react/jsx-runtime";
var PLATFORM_STORE_ID = "platformStoreId";
console.log("new release 2.0.2");
var initialStage = {
  logger: {
    log: console.log,
    debug: console.debug,
    warn: console.warn,
    info: console.info,
    error: console.error
  },
  getSessionId: () => datadogLogs.getInternalContext()?.session_id || "",
  getPlatformStoreId: () => {
    return datadogLogs?.getGlobalContext() ? (datadogLogs?.getGlobalContext()[PLATFORM_STORE_ID] || "")?.toString() : "";
  },
  setPlatformStoreId: (platformStoreId) => datadogLogs?.setGlobalContextProperty(PLATFORM_STORE_ID, platformStoreId),
  datadogLogs
};
var LoggerContext = React.createContext(initialStage);
var LoggerProvider = ({
  children,
  env = "local",
  ddClientToken = "",
  ddService = "",
  configurations,
  errorsToIgnore = [],
  forceLogging = false
}) => {
  let logger = initialStage.logger;
  if ((env === "production" || forceLogging) && ddClientToken) {
    try {
      datadogLogs.init({
        clientToken: ddClientToken,
        site: "datadoghq.com",
        service: ddService,
        env,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        beforeSend: (log) => {
          if (log?.status === "error" || log?.type === "error") {
            const message = log?.message || log?.error?.stack || "";
            if (errorsToIgnore.some(
              (errorToIgnore) => message.includes(errorToIgnore)
            )) {
              return false;
            }
          }
          if (log.http && log.http.status_code === 404) {
            return false;
          }
          return true;
        },
        ...configurations || {}
      });
    } catch (error) {
      console.log(error);
    }
    datadogLogs.onReady(() => {
      window.setPlatformStoreId = (platformStoreId) => {
        return window.DD_LOGS?.setGlobalContextProperty(
          PLATFORM_STORE_ID,
          platformStoreId
        );
      };
      window.getPlatformStoreId = () => {
        return window.DD_LOGS?.getGlobalContext() ? (window.DD_LOGS.getGlobalContext()[PLATFORM_STORE_ID] || "")?.toString() : "";
      };
      window.getSessionId = () => {
        return window.DD_LOGS?.getInternalContext()?.session_id || "";
      };
    });
    const logFunction = (logLevel, arg1, meta) => {
      try {
        if (meta?.error || meta?.err || meta?.e) {
          const { error, err, e, ...errorMeta } = meta;
          const errorObj = error || err || e;
          meta = {
            error: {
              stack: errorObj.stack,
              message: errorObj.message,
              kind: errorObj.name
            },
            ...errorMeta
          };
        }
        switch (logLevel) {
          case "log":
            datadogLogs.logger.log(arg1, { meta });
            break;
          case "debug":
            datadogLogs.logger.debug(arg1, { meta });
            break;
          case "warn":
            datadogLogs.logger.warn(arg1, { meta });
            break;
          case "info":
            datadogLogs.logger.info(arg1, { meta });
            break;
          case "error":
            datadogLogs.logger.error(arg1, { meta });
            break;
          default:
            datadogLogs.logger.log(arg1, { meta });
        }
      } catch (error) {
        console.log("Error while logging:", error, arg1, meta);
      }
    };
    logger = {
      log: (arg1, meta) => logFunction("log", arg1, meta),
      debug: (arg1, meta) => logFunction("debug", arg1, meta),
      warn: (arg1, meta) => logFunction("warn", arg1, meta),
      info: (arg1, meta) => logFunction("info", arg1, meta),
      error: (message, meta) => logFunction("error", message, meta)
    };
  }
  return /* @__PURE__ */ jsx(LoggerContext.Provider, { value: { ...initialStage, logger }, children });
};
export {
  LoggerContext,
  LoggerProvider
};
//# sourceMappingURL=index.js.map